<template>
  <div class="col-xl-6 col-12 mt-3">
    <div
      class="border rounded p-5 mb-5 card-box"
      :class="field.visible ? 'border-primary' : ''"
    >
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div class="d-flex align-items-center">
          <div class="avatar avatar-sm flex-shrink-0 me-2">
            <span
              class="avatar-initial rounded"
              :class="field.visible ? 'bg-label-primary' : 'bg-label-secondary'"
            >
              <i :class="field.icon"></i>
            </span>
          </div>
          <div>
            <h6
              class="mb-0 text-nowrap"
              :class="field.visible ? 'text-primary' : 'text-secondary'"
            >
              {{ field.label }}
            </h6>
          </div>
        </div>
        <div class="me-7">
          <label class="switch switch-square">
            <input
              type="checkbox"
              class="switch-input"
              v-model="field.visible"
              @change="toggleField(field)"
            />
            <span class="switch-toggle-slider">
              <span class="switch-on"><i class="ti ti-check"></i></span>
              <span class="switch-off"><i class="ti ti-x"></i></span>
            </span>
          </label>
        </div>
      </div>

      <div v-if="designer == 'advanced'" class="mt-4">
        <label class="form-label mb-2">{{ $t("batches.position") }}</label>

        <div class="d-flex align-items-center mb-2">
          <span class="me-2 small">U</span>
          <input
            type="range"
            min="0"
            max="100"
            v-model="field.y"
            class="form-range"
            :disabled="!field.visible"
          />
          <span class="ms-2 small">D</span>
        </div>

        <div class="d-flex align-items-center mb-2">
          <span class="me-2 small">L</span>
          <input
            type="range"
            min="0"
            max="100"
            v-model="field.x"
            class="form-range"
            :disabled="!field.visible"
          />
          <span class="ms-2 small">R</span>
        </div>

        <div class="d-flex align-items-center mb-2">
          <span class="me-2 small">S</span>
          <input
            type="range"
            min="0"
            max="100"
            v-model="field.size"
            class="form-range"
            :disabled="!field.visible"
          />
          <span class="ms-2 small">L</span>
        </div>

        <label class="form-label">{{ $t("batches.color") }}</label>
        <input
          class="form-control"
          type="color"
          v-model="field.color"
          :disabled="!field.visible"
        />
      </div>

      <div v-if="designer == 'basic'" class="mt-4">
        <label class="form-label">{{ $t("batches.color") }}</label>
        <input
          class="form-control"
          type="color"
          v-model="field.color"
          :disabled="!field.visible"
        />
      </div>

      <div v-if="field.label === 'QR Code'" class="mt-4">
        <label class="form-label">URL</label>
        <input
          class="form-control"
          type="text"
          placeholder="10.0.0.1"
          v-model="field.url"
          :disabled="!field.visible"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PrintDesigner",
  props: {
    field: {
      type: Object,
      required: true,
    },
    designer: {
      type: String,
      default: "basic",
      required: false,
    },
  },
  methods: {
    toggleField(field) {
      this.$emit("toggle-field", field);
    },
  },
  watch: {
    field: {
      handler(newVal) {
        this.$emit("update-field", newVal);
      },
      deep: true,
    },
  },
};
</script>
